import React, { useState, useEffect } from 'react';
import i18next from 'core/i18n';

import { DocumentsList, IPesquisaSerasaInfo, utils } from 'shared';
import { PesquisaSerasaModal, PesquisaSerasaModalProps } from './components/PesquisaSerasaModal/PesquisaSerasaModal';
import { getDebtTypeTranslated } from 'features/brazil-grower/components/BrazilGrowerFinance/utils';
import { TableRowsTab, TableTab } from 'features/brazil-grower/components/BrazilGrowerFinance/shared/TableTab';
import { PhaseSection, PhaseSectionProps } from '../../PhaseSection';
import { SingleRow } from '../../SingleRow';

export interface PesquisaSerasaProps
  extends Pick<PhaseSectionProps, 'disabled'>,
    Pick<PesquisaSerasaModalProps, 'updateCredit' | 'toUploadFiles'> {
  pesquisaSerasaInfo?: IPesquisaSerasaInfo;
}

interface PesquisaSerasaSectionSummaryProps extends Pick<PesquisaSerasaProps, 'pesquisaSerasaInfo'> {}

export const PesquisaSerasaSectionSummary: React.FunctionComponent<PesquisaSerasaSectionSummaryProps> = ({
  pesquisaSerasaInfo
}) => {
  /**
   * State
   */
  const [rows, setRows] = useState<TableRowsTab[]>([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (pesquisaSerasaInfo?.serasaDebts) {
      const newRows: TableRowsTab[] = [];
      let newTotal = 0;

      pesquisaSerasaInfo.serasaDebts.forEach(debt => {
        newRows.push({
          type: getDebtTypeTranslated(debt.type),
          name: debt.name,
          amount: utils.currency.formatBrazilCurrency(debt.amount),
          contact: debt.contact,
          count: debt.count,
          details: debt.details
        });
        newTotal += debt.amount;
      });

      setRows(newRows);
      setTotal(newTotal);
    }
  }, [pesquisaSerasaInfo]);

  return (
    <div className="width-100">
      {pesquisaSerasaInfo?.serasaConsultationDate ? (
        <SingleRow
          title={i18next.t('consultationDate')}
          content={
            pesquisaSerasaInfo?.serasaConsultationDate
              ? utils.date.formatDate(pesquisaSerasaInfo.serasaConsultationDate)
              : undefined
          }
        />
      ) : null}
      {rows.length ? <TableTab rows={rows} total={utils.currency.formatBrazilCurrency(total)} /> : null}
      {pesquisaSerasaInfo?.serasaObservation ? (
        <SingleRow title={i18next.t('observations')} content={pesquisaSerasaInfo?.serasaObservation} />
      ) : null}
      {pesquisaSerasaInfo?.files?.length ? (
        <SingleRow title={i18next.t('documents')}>
          <DocumentsList documents={pesquisaSerasaInfo?.files || []} isVisible={true} />
        </SingleRow>
      ) : null}
    </div>
  );
};

export const PesquisaSerasa: React.FunctionComponent<PesquisaSerasaProps> = ({
  pesquisaSerasaInfo,
  updateCredit,
  toUploadFiles,
  children,
  ...phaseSectionProps
}) => {
  /**
   * State
   */
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <PhaseSection
        {...phaseSectionProps}
        open={!!pesquisaSerasaInfo}
        renderSeparatorBefore
        onClickEdit={openModal}
        title={i18next.t('serasaSearch_title')}
        disabled={phaseSectionProps.disabled}
      >
        <PesquisaSerasaSectionSummary pesquisaSerasaInfo={pesquisaSerasaInfo} />
      </PhaseSection>
      <PesquisaSerasaModal
        open={modalOpen}
        closeModal={closeModal}
        pesquisaSerasaInfo={pesquisaSerasaInfo}
        updateCredit={updateCredit}
        toUploadFiles={toUploadFiles}
      />
    </>
  );
};
